import { useMemo } from 'react';

// components
import {
  CasEditForm,
  CasRHFTextField,
  CasRHFSwitch,
  IEditForm,
} from 'src/compass/shared/components';

// schema
import { BranchSchema } from './BranchSchema';
import RHFAgencySelect from './RHFAgencySelect';
// ----------------------------------------------------------------------

export default function BranchForm({ row, onSaved }: IEditForm) {
  const { id } = row || {};

  const defaultValues = useMemo(
    () => (id ? row : { isActive: true, isMainOffice: false }),
    [id, row]
  );

  return (
    <CasEditForm
      defaultValues={defaultValues}
      onSaved={onSaved}
      entity="Branch"
      schema={BranchSchema}
    >
      <CasRHFTextField name="name" label="Branch" />
      <RHFAgencySelect name="insAgencyId" label="Agency" includeNoneOption />
      <CasRHFTextField name="eHarvestAliasUser" label="eHarvest User" />
      <CasRHFSwitch name="isMainOffice" label="Is Main Office?" />
      <CasRHFSwitch name="isActive" label="Active" />
    </CasEditForm>
  );
}
